import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

export const DICT = {
  it: {
    nav: {
      collections: 'Collezioni',
      shades: 'Shades',
      build: 'Componi la tavola',
      buildShort: 'Componi',
      xmas: 'Natale',
      whereToBuy: 'Dove comprare',
      magazine: 'Ispirazioni',
      company: 'L’azienda',
      contact: 'Contatti',
      reseller: 'Diventa rivenditore',
      horeca: 'Ho.Re.Ca',
      press: 'Area stampa',
      pro: 'Sei un professionista?',
      consumer: 'Per la tua casa',
      menu: 'Menu',
      close: 'Chiudi',
      skipToContent: 'Vai al contenuto',
      home: 'Torna alla home',
    },
    common: {
      findRetailer: 'Trova dove acquistare',
      becomeReseller: 'Diventa rivenditore',
      payoff: 'Vivi di emozioni',
      galileoStore: 'e-commerce di Galileo S.p.A.',
      buyOnSatur: 'Acquista su satur.it',
      buyOnSaturNote: 'e-commerce di Galileo S.p.A. · si apre in una nuova scheda',
      discoverCollection: 'Scopri la collezione',
      readMore: 'Continua a leggere',
      allCollections: 'Tutte le collezioni',
      products: 'referenze',
      loading: 'Si sta componendo…',
      empty: 'Niente da mostrare con questi filtri. Provane altri.',
      search: 'Cerca un pezzo, una parola, un codice',
      more: 'Vedi tutto',
      railPrev: 'Indietro',
      railNext: 'Avanti',
      since: 'Dal',
      sheet: 'Scheda',
      thumbAlt: (i) => `Immagine ${i}`,
      shade: 'Shade',
      materials: 'Materiali',
      colors: 'Colori',
      dimensions: 'Dimensioni',
      weight: 'Peso',
      care: 'Come si tiene',
      buyProduct: 'Acquista il prodotto',
      technicalNote: 'Nota tecnica',
      technicalNoteHint: 'Misure, peso, dettagli',
      share: 'Condividi',
      copyLink: 'Copia il link',
      linkCopied: 'Link copiato',
      noteInItalian: 'Testo originale in italiano',
      storyCoverCaptionGenerated: 'Scena ricostruita a partire dai pezzi della collezione.',
      pairWith: 'Ci sta bene con',
      sameCollection: 'Della stessa collezione',
      category: 'Categoria',
      send: 'Invia',
      sent: 'Ricevuto. Ti rispondiamo presto, davvero.',
      error: 'Qualcosa non ha funzionato. Riprova tra poco.',
      langLabel: 'Lingua',
      languageIt: 'Italiano',
      languageEn: 'English',
      pauseVideo: 'Metti in pausa il video',
      playVideo: 'Riproduci il video',
      backToTop: 'Torna in cima',
      formOff: 'Il modulo non è attivo al momento.',
      writeTo: 'Scrivici a',
    },
    home: {
      h1a: 'Vivi',
      h1b: 'di emozioni',
      labelPaths: 'Da dove vuoi partire',
      lead:
        'Dal 1996 la tavola non è un servizio tutto uguale: è un racconto che cambia ogni volta che apparecchi. Cento collezioni, un solo stile: il tuo.',
      manifesto1: 'Non una collezione di oggetti, ma una collezione di storie.',
      manifesto2: 'Non uno stile, ma uno spazio.',
      manifesto3: 'Non un catalogo, ma una voce.',
      scroll: 'Scorri',
      heroReelTitle: 'Ogni dettaglio racconta una storia. La nostra inizia a tavola.',
      showroomKicker: 'Tivoli, 3.500 m²',
      showroomTitle: 'Le collezioni, dal vivo',
      showroomCta: 'Scopri lo showroom',
      collectionsTitle: 'Le collezioni che parlano',
      collectionsLead:
        'Ogni collezione nasce nel nostro laboratorio interno, VdE Studio. Poi le mescoli come vuoi.',
      shadesCta: 'Esplora le Shades',
      scompostoTitle: 'Scomposti a tavola',
      scompostoLead:
        'L’intuizione da cui è nato tutto: apparecchiare rompendo le regole. Quattro istruzioni, poi fai da te.',
      rules: [
        ['Tieni fissa la materia', 'Se parti dal gres resta nel gres. Il colore può ballare, la materia no.'],
        ['Un elemento che torna', 'Un bordo, una finitura, una tinta che si ripete almeno tre volte.'],
        ['Conta in dispari', 'Tre tonalità funzionano meglio di quattro. Cinque meglio di sei.'],
        ['Lascia un pezzo fuori posto', 'Uno solo. È quello di cui parleranno.'],
      ],
      magazineTitle: 'Cose che vale la pena leggere',
      b2cTitle: 'Per la tua casa',
      b2cText:
        'Rivenditori sul territorio e l’e-commerce satur.it di Galileo S.p.A.',
      b2bTitle: 'Per il tuo lavoro',
      b2bText:
        'Rivenditori, corner, Ho.Re.Ca: qui trovi come lavorare con noi.',
    },
    collections: {
      title: 'Collezioni',
      lead:
        'Cento collezioni, ognuna con il suo carattere: sceglile, accostale, mescolale.',
      since: 'Trent\'anni di collezioni per la tavola, dal 1996.',
      fallbackStory: 'I pezzi di questa serie sono tutti qui sotto, ciascuno con la sua scheda.',
      curated: 'Le collezioni con un racconto',
      plainTitle: 'Le altre serie',
      plainNote:
        'Pezzi che lavorano insieme, raggruppati per nome e famiglia. Ogni serie ha la sua voce: leggila prima di scegliere.',
      bridgeTitle: 'Cerchi un oggetto, non una collezione?',
      bridgeBody: 'Il catalogo completo è diviso per categoria: piatti, bicchieri, posate, complementi.',
      bridgeCta: 'Vai al catalogo',
      loadError: 'Le collezioni non rispondono. Riprova tra un istante.',
      inCollection: 'In questa collezione',
      howToUse: 'Come si usa',
      victionaryBanner: 'Scopri l’esperienza Victionary: sette capitoli, dizionario e quiz',
    },
    footer: {
      colCatalog: 'Il catalogo',
      colStories: 'Storie',
      colPro: 'B2B e stampa',
      colLegal: 'Legale',
      channelsB2C: 'Per acquistare',
      channelsB2B: 'Per i rivenditori',
      follow: 'Seguici',
    },
    where: {
      title: 'Dove comprare',
      lead:
        'I negozi Satur Passione Casa in tutta Italia, più i canali online: cerca la tua città e scegli come arrivarci.',
      searchPlaceholder: 'Città, CAP, provincia o regione',
      noResults: 'Nessun punto vendita per questa ricerca. Scrivici: ti indichiamo il più vicino.',
      channelsTitle: 'Tre modi per arrivarci',
      storesCount: (n) => `${n} negozi Satur Passione Casa`,
      allRegions: 'Tutte le regioni',
      showMore: 'Mostra altri punti vendita',
      openMaps: 'Apri in Google Maps',
      b2bNote:
        'Hai un negozio e ti interessa un corner o un progetto su misura?',
    },
    company: {
      title: 'Un’azienda nata a Tivoli',
      lead:
        'VdE Tivoli 1996 nasce a Tivoli, l’antica Tibur romana. Da lì viene il nome, il carattere tipografico e l’abitudine a reinventare la tradizione invece di ripeterla.',
      materiaKicker: 'Materia',
      originTitle: 'Origine',
      originText:
        'VdE Tivoli 1996 nasce a Tivoli nel 1996. È un marchio di Galileo S.p.A., azienda attiva dal 1929.',
      tableTitle: 'Dalla materia alla tavola',
      tableText: 'Le collezioni, fotografate dove devono stare: in tavola.',
      showroomTitle: 'Lo showroom',
      showroomAlt: 'Carrellata tra gli scaffali dello showroom, con le collezioni esposte',
      studioTitle: 'VdE Studio',
      studioText:
        'Il laboratorio interno dove nascono forme, colori e collezioni. Ogni pezzo è disegnato dal team creativo, a Tivoli.',
      territoryTitle: 'Tivoli, ovvero Tibur',
      territoryText:
        'Villa d’Este ci ha messo le fontane, Villa Adriana i mosaici, il travertino ha fatto il resto. Il nome, semplificato in VdE, tiene il riferimento e cambia il passo.',
      valuesTitle: 'Tre cose in cui crediamo',
      values: [
        ['Autoespressione', 'La casa è un racconto personale. Non imponiamo uno stile: diamo lo spazio per inventarne uno.'],
        ['Voce', 'La voce è sinonimo di unicità. Non è perfezione, è identità: la serenità di vivere le proprie imperfezioni come segni distintivi.'],
        ['Rivoluzione quotidiana', 'La rivoluzione non è clamore, è movimento. Seguiamo le tendenze per poi ribaltarle.'],
      ],
      seriesKicker: 'Miniserie · 30 anni',
      seriesTitle: 'Trent’anni, in quattro domande',
      seriesLead:
        'Barbara Vitale, brand director, si racconta attraverso i trent’anni di VdE. Quattro puntate brevi, uscite su Instagram tra settembre e ottobre 2026.',
      seriesQuestions: [
        'Da dove è nata l’idea VdE?',
        'Quando hai capito che VdE poteva diventare qualcosa di grande?',
        'Cos’è cambiato in trent’anni?',
        'Se potessi parlare alla te di trent’anni fa, cosa le diresti?',
      ],
      seriesEpisode: (n, tot) => `Puntata ${n} di ${tot}`,
      seriesPlay: (n) => `Guarda la puntata ${n}`,
      seriesVideoAlt: (n) => `Miniserie dei 30 anni, puntata ${n}: intervista a Barbara Vitale, con sottotitoli`,
      seriesSeek: 'Avanzamento della puntata',
      seriesMute: 'Disattiva audio',
      seriesUnmute: 'Attiva audio',
      seriesFullscreen: 'Schermo intero',
      seriesInstagram: 'Segui VdE su Instagram',
      seriesOnInstagram: (n) => `Apri la puntata ${n} su Instagram`,
    },
    magazine: {
      title: 'Ispirazioni',
      lead: 'Metodo, colore, territorio. Quello che non entra in una scheda prodotto.',
    },
    reseller: {
      title: 'Diventa rivenditore',
      lead:
        'Le collezioni VdE arrivano nelle case attraverso i negozi che le scelgono. Ecco cosa trovi lavorando con noi.',
      why: [
        ['Rotazione ogni 2–3 mesi', 'Il negozio è un palcoscenico. Se resta fermo, le persone smettono di muoversi.'],
        ['Il planogramma', 'Come esporre è scritto e spiegato: il corner resta in ordine anche quando cambia chi lo segue.'],
        ['La scatola che parla', 'Il packaging è formazione continua per chi vende, senza consumare tempo di vendita.'],
        ['Un colore riconoscibile', 'Le Shades nascono in VdE Studio e cambiano con le stagioni: lo scaffale si riconosce da lontano.'],
      ],
      formTitle: 'Raccontaci la tua attività',
      horecaTitle: 'Ho.Re.Ca',
      horecaLead:
        'Hotel, ristoranti, bistrot. Una linea pensata per chi apparecchia trecento volte al giorno e non può permettersi di ricominciare da zero ogni stagione.',
      horecaFormTitle: 'Richiedi il catalogo Ho.Re.Ca',
      horecaCasesTitle: 'I clienti Ho.Re.Ca',
      horecaCases: [],
      faireTitle: 'Ordina subito su Faire',
      faireText:
        'Se hai già un negozio e non vuoi aspettare, la nostra brand page su Faire è aperta: catalogo wholesale, termini chiari, primo ordine senza telefonate.',
      faireCta: 'Apri la brand page VdE su Faire',
      faireOr: 'Oppure raccontaci la tua attività: per corner, allestimenti e progetti su misura serve una conversazione.',
    },
    contact: {
      title: 'Scrivici',
      lead: 'Scrivici due righe: il resto lo diciamo rispondendo.',
      infoTitle: 'Altri modi',
      hq: 'Sede',
      commercial: 'Commerciale',
      pressLabel: 'Stampa',
    },
    press: {
      title: 'Area stampa',
      lead:
        'Logo, brand book, materiali. Se scrivi di noi, prendi quello che ti serve. E proteggi i dettagli: si scrive VdE, mai VDE, mai vde.',
      download: 'Scarica',
      rulesTitle: 'Tre regole non negoziabili',
      rules: [
        ['La grafia', 'VdE. Non VDE, non vde. La grafia del marchio non è una variabile tipografica.'],
        ['Il payoff', '«Vivi di emozioni». Unica forma corretta: V di Vivi, d di di, E di emozioni.'],
        ['Lo spazio libero', 'Due volte l’altezza del marchio sopra e sotto, una volta e mezza ai lati.'],
      ],
      paletteTitle: 'La palette',
      kitTitle: 'Tutto il brand kit in un unico file',
      kitLead:
        'Logo in tutte le versioni, brand book 2025 e le specifiche di palette, caratteri e grafia. Un download, niente da mettere insieme.',
      kitContents: [
        'Logo: versione con pennellata ed essenziale, PNG a fondo trasparente',
        'Brand Book VdE 2025, 58 pagine, PDF',
        'LEGGIMI: palette Pantone/HEX, caratteri, le tre regole di grafia e i contatti stampa',
      ],
      kitDownload: 'Scarica il brand kit',
      kitPreparing: 'Preparazione del pacchetto…',
      kitUpdated: 'Aggiornato al',
      singleFiles: 'Oppure i file singoli',
      typeTitle: 'I caratteri',
      typeText:
        'Didot per i titoli: un «romano moderno» che richiama Tibur e il Rinascimento di Villa d’Este. Helvetica per il testo: leggibile, diretta, senza fronzoli. Sul web usiamo Bodoni Moda e Archivo come equivalenti.',
    },
    season: {
      preview: 'Anteprima fuori stagione',
      allPieces: 'Tutti',
      inThePhoto: 'In foto',
      closingTitle: 'Adesso tocca alla tua tavola',
      closingText: 'Parti da un colore: la tavola si compone da sé.',
      tavolaKicker: 'La tavola si apparecchia',
      galleryTitle: 'Le feste, da vicino',
      galleryLead: 'Scatti del nostro archivio, sulle tavole vere.',
    },
    build: {
      kicker: 'Componi la tua tavola',
      title: 'Cinque pezzi, una tavola: la tua',
      lead:
        'Parti da una Shade: ti proponiamo cinque pezzi presi dal catalogo. Cambiali, rompi le regole, guarda cosa dice il punteggio e poi condividi il risultato.',
      pickShade: 'Da quale colore parti?',
      emptyState: 'Scegli una Shade e la tavola si apparecchia da sola.',
      slotsTitle: (shade) => `La tua tavola in ${shade}`,
      resetSuggestion: 'Rifai la proposta',
      slotEmpty: 'Nessun pezzo per questo posto',
      change: 'Cambia pezzo',
      pickerKicker: 'Scegli il pezzo',
      searchPlaceholder: 'Cerca un pezzo o una collezione',
      affinity: {
        shade: 'In Shade',
        colore: 'Nel colore',
        neutro: 'Neutro',
        fuori: 'Fuori Shade',
      },
      scoreTitle: 'Quanto segue il metodo',
      scoreHint:
        'Il punteggio conta le regole del metodo che la tua tavola segue. Quattro su quattro non è l\'obiettivo: tre su quattro è una tavola.',
      rulesTitle: 'Le quattro regole del metodo',
      shareKicker: 'Condividi',
      shareText: 'Un link breve e un’immagine da mandare a chi cucina.',
      share: 'Salva e condividi',
      saving: 'Sto apparecchiando…',
      savedTitle: 'La tua tavola ha un indirizzo',
      whatsappText: 'Ho composto la mia tavola VdE:',
      download: 'Scarica l’immagine',
      openTable: 'Apri la pagina della tavola',
      restart: 'Ricomincia da zero',
      sharedTitle: (shade) => `La tavola di ${shade}`,
      sharedLead:
        'Composta con il configuratore VdE. Ogni pezzo esiste davvero: si acquista su satur.it, l’e-commerce di Galileo S.p.A.',
      pieces: 'I cinque pezzi',
      buildYours: 'Componi la tua',
      notFound: 'Questa tavola non esiste (più)',
      fromShade: 'Componi una tavola in questa Shade',
      prevPiece: 'Pezzo precedente',
      nextPiece: 'Pezzo successivo',
      arrivalKicker: 'Arrivo',
      arrivalTitle: 'La tua tavola è pronta',
      flowColor: 'Colore',
      flowPieces: 'Pezzi',
      flowScore: 'Punteggio',
    },
    shades: {
      title: 'Cinque colori, cento collezioni',
      lead:
        'Una Shade non è una collezione: è una tonalità che torna in pezzi diversi, stagione dopo stagione. Parti dal colore e la tavola si compone da sola.',
      seasonLabel: 'Stagione',
      palette: 'Codice colore',
      storyTitle: 'In una riga',
      notesTitle: 'Come si usa',
      momentsTitle: 'Quando',
      piecesTitle: 'I pezzi',
      piecesTitle: 'Gli oggetti VdE di questa Shade',
      collectionsTitle: 'Le collezioni che la portano',
      pairsTitle: 'Sta bene con',
      othersTitle: 'Le altre Shades',
      back: 'Tutte le Shades',
      editorialNote:
        'Cinque racconti stagionali. Non tutto il catalogo ha una shade: sono gli oggetti che quella stagione l\'ha scelta.',
      photoAlt: 'Le sfumature di casa VdE in un ambiente reale',
      playKicker: 'Componi la tua tavola',
      playTitle: 'La tua tavola in tre mosse',
      exploreTitle: 'Le cinque Shades',
    },
    victionary: {
      metaTitle: 'Victionary: il vocabolario dell’ironia quotidiana',
      metaDesc:
        'Victionary, dal 2017: ogni oggetto è una pagina di dizionario che riscrive il senso delle parole. Una rivista interattiva in sette capitoli.',
    },
    notFound: {
      seoTitle: 'Pagina non trovata',
      title: 'Questa pagina non esiste',
      body: 'L’indirizzo digitato non corrisponde a nessuna pagina del sito. Puoi tornare alla home o scoprire dove trovare i nostri prodotti.',
    },
    unsubscribe: {
      seoTitle: 'Disiscrizione dalla newsletter',
      title: 'Vuoi disiscriverti?',
      body: 'Confermando, il tuo indirizzo viene rimosso dalla lista e non ricevi più nostre email.',
      confirm: 'Conferma la disiscrizione',
      done: 'Fatto. Il tuo indirizzo è stato rimosso.',
      invalid: 'Questo link non è valido. Se hai ricevuto una nostra email, riapri il link che contiene.',
      error: 'Non è stato possibile completare la richiesta. Riprova tra poco.',
      back: 'Torna alla home',
    },
    stories: {
      title: 'Storie',
      intro: 'Da dove vengono le cose che mettiamo in tavola, e perché le abbiamo fatte così.',
      seoTitle: 'Storie',
      seoDesc: 'Articoli, shades stagionali, il Victionary. Il racconto dietro gli oggetti VdE.',
      articles: 'Ispirazioni',
      articlesBody: 'Metodo, colore, territorio: gli articoli.',
      shades: 'Shades',
      shadesBody: 'Cinque racconti stagionali e gli oggetti che li portano.',
      victionary: 'Victionary',
      victionaryBody: 'Il dizionario delle voci che stanno scritte sui nostri oggetti.',
      xmas: 'Natale',
      xmasBody: 'Il calendario dell\'avvento e le referenze della stagione.',
    },
    catalog: {
      title: 'Catalogo',
      intro: 'Tutte le categorie VdE Tivoli 1996, divise per uso. Scegli un mondo o vai dritto alla categoria.',
      seoTitle: 'Catalogo',
      seoDesc:
        'Il catalogo VdE diviso per uso: tavola, cottura, dispensa, ambienti, bagno, feste. Filtra per Shade, materiale e colore. Oltre mille referenze da mescolare.',
      countLabel: (n) => `${n} referenz${n === 1 ? 'a' : 'e'}`,
      worldLead: 'Gli oggetti VdE di questo mondo: restringi per categoria, o guarda e lascia che siano loro a dirti dove vogliono stare.',
      salesKicker: 'Ufficio commerciale',
      salesTitle: 'Rivenditori, Ho.Re.Ca e progetti per il punto vendita',
      worldAll: 'Vedi tutto',
      collectionsHint: 'Cerchi una famiglia di pezzi pensati per stare insieme?',
      collectionsHintCta: 'Guarda le collezioni',
      empty: 'Questa categoria è momentaneamente vuota.',
      notFound: 'Questa categoria non esiste. Forse è stata rinominata, o cercavi qualcos\'altro.',
      backToCatalog: 'Torna al catalogo',
      loadError: 'Il catalogo non risponde. Riprova tra un istante.',
    },
  },
  en: {
    nav: {
      collections: 'Collections',
      shades: 'Shades',
      build: 'Build your table',
      buildShort: 'Build',
      xmas: 'Christmas',
      whereToBuy: 'Where to buy',
      magazine: 'Inspiration',
      company: 'The company',
      contact: 'Contact',
      reseller: 'Become a retailer',
      horeca: 'Ho.Re.Ca',
      press: 'Press area',
      pro: 'Are you a professional?',
      consumer: 'For your home',
      menu: 'Menu',
      close: 'Close',
      skipToContent: 'Skip to content',
      home: 'Back to the homepage',
    },
    common: {
      findRetailer: 'Find where to buy',
      becomeReseller: 'Become a retailer',
      payoff: 'Vivi di emozioni',
      galileoStore: 'Galileo S.p.A. online store',
      buyOnSatur: 'Buy on satur.it',
      buyOnSaturNote: 'Galileo S.p.A. online store · opens in a new tab',
      discoverCollection: 'Discover the collection',
      readMore: 'Keep reading',
      allCollections: 'All collections',
      products: 'references',
      loading: 'Setting the table…',
      empty: 'Nothing to show with these filters. Try others.',
      search: 'Search a piece, a word, a code',
      more: 'See all',
      railPrev: 'Back',
      railNext: 'Forward',
      since: 'Since',
      sheet: 'Details',
      thumbAlt: (i) => `Image ${i}`,
      shade: 'Shade',
      materials: 'Materials',
      colors: 'Colours',
      dimensions: 'Dimensions',
      weight: 'Weight',
      care: 'How to keep it',
      buyProduct: 'Buy the product',
      technicalNote: 'Technical note',
      technicalNoteHint: 'Sizes, weight, details',
      share: 'Share',
      copyLink: 'Copy the link',
      linkCopied: 'Link copied',
      noteInItalian: 'Original text, in Italian',
      storyCoverCaptionGenerated: 'Scene recreated from the pieces in the collection.',
      pairWith: 'Goes well with',
      sameCollection: 'From the same collection',
      category: 'Category',
      send: 'Send',
      sent: 'Got it. We’ll reply soon. Really.',
      error: 'Something went wrong. Try again shortly.',
      langLabel: 'Language',
      languageIt: 'Italiano',
      languageEn: 'English',
      pauseVideo: 'Pause the video',
      playVideo: 'Play the video',
      backToTop: 'Back to top',
      formOff: 'This form is currently not available.',
      writeTo: 'Write to us at',
    },
    home: {
      h1a: 'Live',
      h1b: 'on emotions',
      labelPaths: 'Where do you want to start',
      lead:
        'Since 1996 the table hasn’t been a matching set: it’s a story that changes every time you lay it. A hundred collections, one style: yours.',
      manifesto1: 'Not a collection of objects, but a collection of stories.',
      manifesto2: 'Not a style, but a space.',
      manifesto3: 'Not a catalogue, but a voice.',
      scroll: 'Scroll',
      heroReelTitle: 'Every detail tells a story. Ours begins at the table.',
      showroomKicker: 'Tivoli, 3,500 sqm',
      showroomTitle: 'The collections, in person',
      showroomCta: 'Discover the showroom',
      collectionsTitle: 'Collections that talk',
      collectionsLead:
        'Every collection is born in VdE Studio, our in-house lab. Then you mix them however you like.',
      shadesCta: 'Explore the Shades',
      scompostoTitle: 'A decomposed table',
      scompostoLead:
        'The insight everything came from: lay the table by breaking the rules. Four instructions, then you’re on your own.',
      rules: [
        ['Keep the material fixed', 'Start with stoneware, stay in stoneware. Colour can dance, matter can’t.'],
        ['One recurring element', 'An edge, a finish, a tone that repeats at least three times.'],
        ['Count in odd numbers', 'Three tones beat four. Five beat six.'],
        ['Leave one piece out of place', 'Only one. That’s what people will talk about.'],
      ],
      magazineTitle: 'Things worth reading',
      b2cTitle: 'For your home',
      b2cText:
        'Local retailers and the satur.it online store of Galileo S.p.A.',
      b2bTitle: 'For your business',
      b2bText:
        'Retailers, corners, Ho.Re.Ca: here’s how to work with us.',
    },
    collections: {
      title: 'Collections',
      lead:
        'A hundred collections, each with its own character: pick them, pair them, mix them.',
      since: 'Thirty years of collections for the table, since 1996.',
      fallbackStory: 'Every piece in this series is below, each with its own sheet.',
      curated: 'The collections with a story',
      plainTitle: 'The other series',
      plainNote: 'The other VdE Tivoli 1996 series, grouped by name and family.',
      bridgeTitle: 'Looking for an object, not a collection?',
      bridgeBody: 'The full catalogue is sorted by category: plates, glassware, cutlery, accessories.',
      bridgeCta: 'Go to the catalogue',
      loadError: 'Collections are not responding. Please try again shortly.',
      inCollection: 'In this collection',
      howToUse: 'How to use it',
      victionaryBanner: 'Discover the Victionary experience: seven chapters, dictionary and quiz',
    },
    footer: {
      colCatalog: 'The catalogue',
      colStories: 'Stories',
      colPro: 'B2B and press',
      colLegal: 'Legal',
      channelsB2C: 'Where to buy',
      channelsB2B: 'For retailers',
      follow: 'Follow us',
    },
    where: {
      title: 'Where to buy',
      lead:
        'Satur Passione Casa stores across Italy, plus the online channels: search your city and pick how to get there.',
      searchPlaceholder: 'City, postcode, province or region',
      noResults: 'No store for this search. Write to us: we’ll point you to the nearest one.',
      channelsTitle: 'Three ways to get there',
      storesCount: (n) => `${n} Satur Passione Casa stores`,
      allRegions: 'All regions',
      showMore: 'Show more stores',
      openMaps: 'Open in Google Maps',
      b2bNote:
        'Run a shop and interested in a corner or a tailored project?',
    },
    company: {
      title: 'A company born in Tivoli',
      lead:
        'VdE Tivoli 1996 was born in Tivoli, ancient Roman Tibur. That’s where the name comes from, the typeface too, and the habit of reinventing tradition instead of repeating it.',
      materiaKicker: 'Material',
      originTitle: 'Origin',
      originText:
        'VdE Tivoli 1996 was born in Tivoli in 1996. It is a brand of Galileo S.p.A., a company active since 1929.',
      tableTitle: 'From material to table',
      tableText: 'The collections, photographed where they belong: on the table.',
      showroomTitle: 'The showroom',
      showroomAlt: 'A slow pan across the showroom shelves, with the collections on display',
      studioTitle: 'VdE Studio',
      studioText:
        'The in-house lab where shapes, colours and collections are born. Every piece is designed by the creative team, in Tivoli.',
      territoryTitle: 'Tivoli, or Tibur',
      territoryText:
        'Villa d’Este added the fountains, Villa Adriana the mosaics, travertine did the rest. The name, shortened to VdE, keeps the reference and changes the pace.',
      valuesTitle: 'Three things we believe in',
      values: [
        ['Self-expression', 'Home is a personal narrative. We don’t impose a style: we give room to invent one.'],
        ['Voice', 'Voice means uniqueness. Not perfection. Identity: the ease of living your imperfections as distinguishing marks.'],
        ['Daily revolution', 'Revolution isn’t noise, it’s movement. We follow trends in order to overturn them.'],
      ],
      seriesKicker: 'Mini-series · 30 years',
      seriesTitle: 'Thirty years, in four questions',
      seriesLead:
        'Barbara Vitale, brand director, looks back on thirty years of VdE. Four short episodes, released on Instagram in September and October 2026. In Italian, with Italian subtitles.',
      seriesQuestions: [
        'Where did the idea of VdE come from?',
        'When did you realise VdE could become something big?',
        'What has changed in thirty years?',
        'If you could speak to yourself thirty years ago, what would you tell her?',
      ],
      seriesEpisode: (n, tot) => `Episode ${n} of ${tot}`,
      seriesPlay: (n) => `Watch episode ${n}`,
      seriesVideoAlt: (n) => `30th anniversary mini-series, episode ${n}: interview with Barbara Vitale, with Italian subtitles`,
      seriesSeek: 'Episode progress',
      seriesMute: 'Mute',
      seriesUnmute: 'Unmute',
      seriesFullscreen: 'Full screen',
      seriesInstagram: 'Follow VdE on Instagram',
      seriesOnInstagram: (n) => `Open episode ${n} on Instagram`,
    },
    magazine: {
      title: 'Inspiration',
      lead: 'Method, colour, territory. Everything that doesn’t fit a product sheet.',
    },
    reseller: {
      title: 'Become a retailer',
      lead:
        'VdE collections reach people’s homes through the shops that choose them. Here’s what working with us looks like.',
      why: [
        ['Rotation every 2–3 months', 'The shop is a stage. If it stands still, people stop moving.'],
        ['The planogram', 'How to display is written down and explained: the corner stays in order even when staff changes.'],
        ['The talking box', 'Packaging is ongoing training for sales staff, without eating selling time.'],
        ['A recognisable colour', 'The Shades are developed by VdE Studio and change with the seasons: the shelf is recognisable from afar.'],
      ],
      formTitle: 'Tell us about your business',
      horecaTitle: 'Ho.Re.Ca',
      horecaLead:
        'Hotels, restaurants, bistros. A line made for those who set the table three hundred times a day and can’t start over every season.',
      horecaFormTitle: 'Request the Ho.Re.Ca catalogue',
      horecaCasesTitle: 'Ho.Re.Ca clients',
      horecaCases: [],
      faireTitle: 'Order right now on Faire',
      faireText:
        'Already running a shop and don’t want to wait? Our Faire brand page is open: wholesale catalogue, clear terms, first order without a single phone call.',
      faireCta: 'Open the VdE brand page on Faire',
      faireOr: 'Or tell us about your business: corners, displays and tailored projects need a conversation.',
    },
    contact: {
      title: 'Write to us',
      lead: 'Drop us a line: we’ll say the rest when we reply.',
      infoTitle: 'Other ways',
      hq: 'Head office',
      commercial: 'Sales',
      pressLabel: 'Press',
    },
    press: {
      title: 'Press area',
      lead:
        'Logo, brand book, materials. If you write about us, take what you need. And protect the details: it’s VdE, never VDE, never vde.',
      download: 'Download',
      rulesTitle: 'Three non-negotiable rules',
      rules: [
        ['The spelling', 'VdE. Not VDE, not vde. The spelling of the mark is not a typographic variable.'],
        ['The payoff', '«Vivi di emozioni». The only correct form: V for Vivi, d for di, E for emozioni.'],
        ['Clear space', 'Twice the height of the mark above and below, one and a half at the sides.'],
      ],
      paletteTitle: 'The palette',
      kitTitle: 'The whole brand kit in a single file',
      kitLead:
        'Every logo version, the 2025 brand book and the specs for palette, typefaces and spelling. One download, nothing to assemble.',
      kitContents: [
        'Logo: brushstroke and essential version, transparent PNG',
        'VdE Brand Book 2025, 58 pages, PDF',
        'READ ME: Pantone/HEX palette, typefaces, the three spelling rules and press contacts',
      ],
      kitDownload: 'Download the brand kit',
      kitPreparing: 'Preparing the package…',
      kitUpdated: 'Updated on',
      singleFiles: 'Or the single files',
      typeTitle: 'The typefaces',
      typeText:
        'Didot for headings: a «modern Roman» recalling Tibur and the Renaissance of Villa d’Este. Helvetica for body text: legible, direct, no frills. On the web we use Bodoni Moda and Archivo as equivalents.',
    },
    season: {
      preview: 'Out-of-season preview',
      allPieces: 'All',
      inThePhoto: 'In the photo',
      closingTitle: 'Now it is your table’s turn',
      closingText: 'Start from a colour: the table lays itself.',
      tavolaKicker: 'Setting the table',
      galleryTitle: 'The holidays, up close',
      galleryLead: 'From our archive, on real tables.',
    },
    build: {
      kicker: 'Build your table',
      title: 'Five pieces, one table: yours',
      lead:
        'Start from a Shade: we suggest five pieces from the catalogue. Swap them, break the rules, watch the score and share the result.',
      pickShade: 'Which colour do you start from?',
      emptyState: 'Pick a Shade and the table lays itself.',
      slotsTitle: (shade) => `Your table in ${shade}`,
      resetSuggestion: 'Suggest again',
      slotEmpty: 'No piece for this place',
      change: 'Change piece',
      pickerKicker: 'Choose the piece',
      searchPlaceholder: 'Search a piece or a collection',
      affinity: {
        shade: 'In Shade',
        colore: 'In colour',
        neutro: 'Neutral',
        fuori: 'Off Shade',
      },
      scoreTitle: 'How closely it follows the method',
      scoreHint:
        'The score counts how many method rules your table follows. Four out of four is not the goal: three out of four is a table.',
      rulesTitle: 'The four rules of the method',
      shareKicker: 'Share',
      shareText: 'A short link and an image to send whoever is cooking.',
      share: 'Save and share',
      saving: 'Laying the table…',
      savedTitle: 'Your table has an address',
      whatsappText: 'I built my VdE table:',
      download: 'Download the image',
      openTable: 'Open the table page',
      restart: 'Start over',
      sharedTitle: (shade) => `The table of ${shade}`,
      sharedLead:
        'Built with the VdE configurator. Every piece is real: available on satur.it, the Galileo S.p.A. online store.',
      pieces: 'The five pieces',
      buildYours: 'Build yours',
      notFound: 'This table doesn’t exist (any more)',
      fromShade: 'Build a table in this Shade',
      prevPiece: 'Previous piece',
      nextPiece: 'Next piece',
      arrivalKicker: 'Arrival',
      arrivalTitle: 'Your table is set',
      flowColor: 'Colour',
      flowPieces: 'Pieces',
      flowScore: 'Score',
    },
    shades: {
      title: 'Five colours, a hundred collections',
      lead:
        'A Shade isn’t a collection: it’s a tone that comes back in different pieces, season after season. Start from the colour and the table lays itself.',
      seasonLabel: 'Season',
      palette: 'Colour code',
      storyTitle: 'In one line',
      notesTitle: 'How to use it',
      momentsTitle: 'When',
      piecesTitle: 'The pieces',
      piecesTitle: 'The VdE objects in this Shade',
      collectionsTitle: 'Collections carrying it',
      pairsTitle: 'Goes well with',
      othersTitle: 'The other Shades',
      back: 'All Shades',
      editorialNote:
        'Five seasonal stories. Not every object has a shade. These are the ones the season picked.',
      photoAlt: 'The shades of a VdE home in a real setting',
      playKicker: 'Build your table',
      playTitle: 'Your table in three moves',
      exploreTitle: 'The five Shades',
    },
    victionary: {
      metaTitle: 'Victionary: the dictionary of everyday irony',
      metaDesc:
        'Victionary, since 2017: every object is a dictionary page rewriting the meaning of words. An interactive magazine in seven chapters.',
    },
    notFound: {
      seoTitle: 'Page not found',
      title: 'This page doesn’t exist',
      body: 'The address you typed doesn’t match any page on the site. You can head back to the homepage or find out where to buy our products.',
    },
    unsubscribe: {
      seoTitle: 'Newsletter unsubscribe',
      title: 'Do you want to unsubscribe?',
      body: 'Once you confirm, your address is removed from the list and you stop receiving our emails.',
      confirm: 'Confirm unsubscribe',
      done: 'Done. Your address has been removed.',
      invalid: 'This link isn’t valid. If you received an email from us, open the link it contains.',
      error: 'We couldn’t complete the request. Please try again shortly.',
      back: 'Back to homepage',
    },
    stories: {
      title: 'Stories',
      intro: 'Where the things we put on the table come from, and why we made them this way.',
      seoTitle: 'Stories',
      seoDesc: 'Articles, seasonal shades, the Victionary. The story behind VdE objects.',
      articles: 'Inspirations',
      articlesBody: 'Method, colour, territory: the articles.',
      shades: 'Shades',
      shadesBody: 'Five seasonal stories and the objects that carry them.',
      victionary: 'Victionary',
      victionaryBody: 'The dictionary of the words written on our objects.',
      xmas: 'Christmas',
      xmasBody: 'The advent calendar and this season\'s pieces.',
    },
    catalog: {
      title: 'Catalogue',
      intro: 'Every VdE Tivoli 1996 category, sorted by use. Pick a world or go straight to the category.',
      seoTitle: 'Catalogue',
      seoDesc:
        'The VdE catalogue by use: table, cooking, pantry, rooms, bathroom, celebrations. Filter by Shade, material and colour. Over a thousand references to mix.',
      countLabel: (n) => `${n} item${n === 1 ? '' : 's'}`,
      worldLead: 'The VdE Tivoli 1996 objects of this world. Narrow it down by category, or just look and get inspired.',
      salesKicker: 'Sales office',
      salesTitle: 'Retailers, Ho.Re.Ca and point-of-sale projects',
      worldAll: 'See all',
      collectionsHint: 'Looking for a family of pieces designed to live together?',
      collectionsHintCta: 'See the collections',
      empty: 'This category is currently empty.',
      notFound: 'This category does not exist. It may have been renamed, or you were looking for something else.',
      backToCatalog: 'Back to the catalogue',
      loadError: 'The catalogue is not responding. Please try again shortly.',
    },
  },
};

const LangContext = createContext({ lang: 'it', setLang: () => {}, t: () => '' });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const q = new URLSearchParams(window.location.search).get('lang');
    if (q === 'en' || q === 'it') return q;
    if (/^\/en(\/|$)/.test(window.location.pathname)) return 'en';
    try {
      return localStorage.getItem('vde-lang') || 'it';
    } catch {
      return 'it';
    }
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // 'vde-lang' si scrive solo quando l'utente sceglie la lingua (cookie policy):
  // al caricamento e dall'URL ?lang= la chiave viene solo letta.
  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem('vde-lang', l);
    } catch {
      /* storage non disponibile: la scelta vale per la sessione */
    }
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split('.');
      let node = DICT[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) break;
      }
      if (node === undefined) {
        let fb = DICT.it;
        for (const p of parts) fb = fb?.[p];
        return fb ?? path;
      }
      return node;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
